import { sampleEventId } from '../fixture-ids';

export const sampleEventEntries = {
  SAMPLE_EVENT_CREATED: {
    entity: 'sampleEvent',
    identity: 'record',
    idKeys: ['id'],
    renderMode: 'diff',
    createsRecord: true,
  },
  SAMPLE_EVENT_UPDATED: {
    entity: 'sampleEvent',
    identity: 'record',
    idKeys: ['id'],
    renderMode: 'diff',
    createsRecord: false,
  },
  SAMPLE_EVENT_DELETED: {
    entity: 'sampleEvent',
    identity: 'record',
    idKeys: ['id'],
    renderMode: 'diff',
    createsRecord: false,
  },
};

export const sampleEventFixtures = {
  SAMPLE_EVENT_CREATED: {
    action: 'SAMPLE_EVENT_CREATED',
    debugData: {
      id: sampleEventId,
      name: 'Checkout completed sample',
      description: 'Example payload for checkout_completed',
    },
  },
  SAMPLE_EVENT_UPDATED: {
    action: 'SAMPLE_EVENT_UPDATED',
    debugData: {
      id: sampleEventId,
      name: 'Checkout completed sample',
      description: 'Example payload for checkout_completed (v2 shape)',
    },
  },
  SAMPLE_EVENT_DELETED: {
    action: 'SAMPLE_EVENT_DELETED',
    debugData: {
      id: sampleEventId,
      name: 'Checkout completed sample',
      description: 'Example payload for checkout_completed (v2 shape)',
    },
  },
};
